import styled from '@emotion/styled';
import CopyIcon from '../../_common/Icons/CopyIcon';
import MoveIcon from '../../_common/Icons/MoveIcon';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import { selectVfsTaskTypes } from '@/redux/selectors/constantsSelectors';
import { useSelector } from 'react-redux';

interface TransferQueueActionProps {
  action: string;
}

const TransferQueueAction = ({ action }: TransferQueueActionProps) => {
  const vfsTaskTypes = useSelector(selectVfsTaskTypes);
  const prettyTaskNames = Object.keys(vfsTaskTypes).reduce(
    (acc, key) => {
      const label = vfsTaskTypes[key];
      acc[key] = label.includes('File') ? label.replace('File', '').trim() : key == 'create_dir' ? 'New Folder' : label;
      return acc;
    },
    {} as Record<string, string>
  );

  const getIcon = () => {
    switch (action) {
      case 'copy_file':
        return <CopyIcon />;
      case 'move_file':
        return <MoveIcon />;
      case 'download_file':
        return <PolarisIcon icon="download" />;
      case 'upload_file':
        return <PolarisIcon icon="upload" />;
      case 'create_dir':
        return <PolarisIcon icon="folder_outline" />;
      default:
        return null;
    }
  };

  return (
    <Action action={action}>
      {getIcon()}
      {prettyTaskNames[action]}
    </Action>
  );
};

export default TransferQueueAction;

const Action = styled.div<{ action: TransferQueueActionProps['action'] }>`
  display: flex;
  align-items: center;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  padding: ${({ theme }) => theme.spacing(0.5, 1, 0.5, 0.5)};
  border-radius: 3px;
  white-space: nowrap;
  width: fit-content;
  text-transform: uppercase;
  ${({ action, theme }) => {
    let color = theme.palette.default.main;
    switch (action) {
      case 'copy_file':
        color = theme.palette.info.main;
        break;
      case 'move_file':
        color = theme.palette.warning.main;
        break;
      case 'upload_file':
        color = theme.palette.lavender.main;
        break;
      case 'download_file':
        color = theme.palette.teal.main;
        break;
      default:
        color = theme.palette.default.main;
        break;
    }

    return `
      background: ${color}2a;
      color: ${color};
      border: 1px dashed ${color};

    `;
  }}

  & > svg {
    margin-right: ${({ theme }) => theme.spacing(0.5)};
    font-size: 1.33rem;
  }
`;
